import { request } from './http';
import { AnalyticsImport, ImportProvider } from './types';

const base = (projectId: string) =>
  `/integrations/project/${encodeURIComponent(projectId)}/imports`;

export const listImports = (projectId: string) =>
  request<{ imports: AnalyticsImport[] }>(base(projectId), 'GET');

/**
 * Creates the import record and returns a presigned S3 URL the archive must be
 * PUT to within 15 minutes. Processing starts automatically once the upload
 * lands; poll `listImports` for the status. A 400 carries a message suitable
 * for showing to the user.
 */
export const createImport = (
  projectId: string,
  body: { provider: ImportProvider },
) =>
  request<{ import: AnalyticsImport; uploadUrl: string }, typeof body>(
    base(projectId),
    'POST',
    body,
  );

export const deleteImport = (projectId: string, importId: string) =>
  request<{ message: string }>(
    `${base(projectId)}/${encodeURIComponent(importId)}`,
    'DELETE',
  );

/**
 * Deliberately outside `request()`: the presigned URL is its own authority, so
 * no cookies, no organization header, and exactly the content type S3 signed.
 */
export const uploadImportArchive = async (
  uploadUrl: string,
  file: Blob,
): Promise<void> => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/zip' },
    body: file,
  });
  if (!response.ok) {
    throw new Error(`Upload failed with status ${response.status}`);
  }
};
